import React from 'react';
import { classnames, TArg, TTailwindString } from 'tailwindcss-classnames';

export type ContainerSize = 'standard' | 'standard-flush';

const containerSizes: Record<string, TArg> = {
  ['2xl']: 'max-w-screen-2xl',
};

const containerMargins: Record<string, TTailwindString> = {
  ['default']: classnames('mx-auto', 'w-full'),
  ['all']: classnames('-mx-gutter-all'),
  ['standard']: classnames('2xl:mx-auto', '2xl:w-full'),
};

export type ContainerProps = {
  size: ContainerSize;
  children: React.ReactNode | React.ReactNode[];
  className?: TTailwindString | TArg;
  dataComponent?: string;
  uid?: string;
};

const sizes: Record<string, { width: TArg; margin?: TTailwindString | TArg }> = {
  ['standard']: {
    width: containerSizes['2xl'],
  },
  ['standard-flush']: {
    width: containerSizes['2xl'],
    margin: `${containerMargins['all']} ${containerMargins['standard']}` as TTailwindString,
  },
};

const Container = ({
  size,
  children,
  className,
  dataComponent,
  uid,
}: ContainerProps): JSX.Element => {
  const validSize = typeof size !== 'undefined' && sizes.hasOwnProperty(size) ? size : 'standard';
  const hasMarginModifiers =
    typeof sizes[validSize].margin !== 'undefined' && sizes[validSize].margin !== null
      ? true
      : false;

  return (
    // min-w-0 resolves the CSS Grid max width problem with % width children.
    <div
      className={classnames(
        sizes[validSize].width,
        {
          [sizes[validSize].margin as string]: hasMarginModifiers,
          [containerMargins['default']]: !hasMarginModifiers,
        },
        className
      )}
      data-component={dataComponent || 'helpers/container'}
      data-uid={uid}
    >
      {children}
    </div>
  );
};

export default Container;
